module.exports = __webpack_public_path__ + "static/media/dtj-logos-1.09b0c9ce.jpg";